export const styles = theme => ({
    chip: {
        margin: theme.spacing(0.5),
    },
    section2: {
        margin: theme.spacing(2),
    },
})
